import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AdministrarCuentaService } from "src/app/servicios/administrar-cuenta.service";
import { Router } from '@angular/router';
import { Meta } from '@angular/platform-browser';

const phoneRegex = /^[0-9]{10}$/;
const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

@Component({
  selector: 'app-tufesapack-paktcambies',
  templateUrl: './tufesapack-paktcambies.component.html',
  styleUrls: ['./tufesapack-paktcambies.component.css']
})
export class TufesapackPaktcambiesComponent implements OnInit {
  formulario: FormGroup;

    // datos que se capturan
    nombre: string;
    correo: string;
    telefono: string;
    tipoPromo: string = "PROMOPKTCAM25";
    via: string ="";

    //datos del endpoint
    dataemail : any;
    msg: string;
    isPopupOpen = false;

  constructor(private formBuilder: FormBuilder, private administrarCuentaService: AdministrarCuentaService, private router: Router, private metaService: Meta) { }

  ngOnInit(): void {
     this.formulario = this.formBuilder.group({
          nombre: ['', Validators.required],
          correo: ['', [Validators.required, Validators.email, Validators.pattern(emailRegex)]],
          telefono: ['', [Validators.required,Validators.pattern(phoneRegex)]]
        });

           this.metaService.updateTag({ name: 'robots', content: 'noindex' });
  }

  // obtenerCodigo(){
  //   this.administrarCuentaService.obtenerPromo(this.formulario.controls.nombre.value, this.formulario.controls.correo.value, this.formulario.controls.telefono.value, this.via, this.tipoPromo).then((data) => {
  //     this.dataemail = data;
  //     if ((this.dataemail.msg) === "1") {
  //       this.showMensaje(this.dataemail.msg);
  //        document.getElementById("mensajeAlert").style.display = "block";
  //     } else {
  //       this.showMensaje(this.dataemail.msg);
  //       document.getElementById("mensajeAlert").style.display = "block";
  //     }
  // });
  // }

 obtenerCodigo() {
  this.administrarCuentaService.obtenerPromo(
    this.formulario.controls.nombre.value,
    this.formulario.controls.correo.value,
    this.formulario.controls.telefono.value,
    this.via,
    this.tipoPromo
  ).then((data) => {
    this.dataemail = data;
    const mensaje = this.dataemail.msg;
    // Redirige a thanku-page con el mensaje como parámetro
   this.router.navigate(['/thanku-page'], {
  state: { msg: mensaje }
  });
  });
}

  showMensaje(msg: string) {
    this.msg = msg;
  }

  get userF() {
    return this.formulario.controls;
  }

  submitForm() {
    if (this.formulario.valid) {
      this.obtenerCodigo();
    }
  }

   openPopup() {
    this.isPopupOpen = true;
  }

  closePopup() {
    this.isPopupOpen = false;
  }
}
